
import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface UnifiedLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
}

export const UnifiedLoader: React.FC<UnifiedLoaderProps> = ({ 
  message = "Loading...", 
  size = 'md',
  className,
  fullScreen = false
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const containerClasses = fullScreen 
    ? 'flex justify-center items-center min-h-screen'
    : 'flex justify-center items-center p-8';

  return (
    <div className={cn(containerClasses, className)}>
      <div className="flex flex-col items-center space-y-3">
        <Loader2 className={cn(sizeClasses[size], 'animate-spin text-amber-600')} />
        {message && (
          <p className={cn(textSizeClasses[size], 'text-gray-600 animate-pulse')}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
